import {
    ArraySchemaElement,
    HiddenSchemaElement,
    SchemaElement,
    SchemaElementType,
    TabSchemaElement,
    WidgetConfiguration,
} from './types';
import { buildSettingsDefaults } from './buildSetting';
import { parseTabSchemaDefaults } from './tabParser';

export function parseArraySchemaDefaults(arraySchemaElement: ArraySchemaElement): WidgetConfiguration {
    let configuration: WidgetConfiguration = {};

    const { defaultCount = 1, schema: arraySchema, id: arraySchemaId } = arraySchemaElement;
    configuration[arraySchemaId] = [];
    let arrayElementConfiguration: WidgetConfiguration = {};
    arraySchema.forEach((schemaElement: SchemaElement) => {
        if (schemaElement.type === SchemaElementType.TAB) {
            const tabSchemaElement = schemaElement as TabSchemaElement;
            const tabSettingDefaults = parseTabSchemaDefaults(tabSchemaElement.sections);
            arrayElementConfiguration = {
                ...arrayElementConfiguration,
                ...tabSettingDefaults,
            };
        }

        if (schemaElement.type === SchemaElementType.HIDDEN) {
            const hiddenSchemaElement = schemaElement as HiddenSchemaElement;
            const hiddenSettingDefaults = buildSettingsDefaults(hiddenSchemaElement.settings);

            arrayElementConfiguration = {
                ...arrayElementConfiguration,
                ...hiddenSettingDefaults,
            };
        }
    });

    for (let i = 1; i <= defaultCount; i++) {
        configuration[arraySchemaId].push({ ...arrayElementConfiguration });
    }

    arraySchema.forEach((schemaElement: TabSchemaElement | ArraySchemaElement) => {
        if (schemaElement.type === SchemaElementType.ARRAY) {
            const subArraySchemaElement = schemaElement as ArraySchemaElement;
            const arrayConfiguration = parseArraySchemaDefaults(subArraySchemaElement);
            configuration = {
                ...configuration,
                ...arrayConfiguration,
            };
        }
    });

    return configuration;
}
